module.exports = __webpack_public_path__ + "img/faxian.0398b072.png";